/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import StatCardItem from '../items/StatCard';

const propTypes = {
    summary: PropTypes.shape({
        sessions: PropTypes.number,
        users: PropTypes.number,
        pageViews: PropTypes.number,
        duration: PropTypes.number,
    }),
    className: PropTypes.string,
};

const defaultProps = {
    summary: null,
    className: null,
};

const Summary = ({ summary, className }) => {
    const { sessions = 0, bounces = 0, pageViews = 0, duration = 0 } = summary || {};

    const durationFormatted = useMemo(
        () => new Date(duration * 1000).toISOString().substr(11, 8),
        [duration],
    );
    return (
        <div className={classNames([{ [className]: className !== null }, 'container'])}>
            <div className="row">
                <StatCardItem
                    className="col-sm"
                    label={
                        <FormattedMessage defaultMessage="Sessions" description="Sessions label" />
                    }
                    value={sessions}
                />
                <StatCardItem
                    className="col-sm"
                    label={
                        <FormattedMessage
                            defaultMessage="Page views"
                            description="Page views label"
                        />
                    }
                    value={pageViews}
                />
                <StatCardItem
                    className="col-sm"
                    label={
                        <FormattedMessage defaultMessage="Bounces" description="Bounces label" />
                    }
                    value={bounces}
                />
                <StatCardItem
                    className="col-sm"
                    label={
                        <FormattedMessage defaultMessage="Duration" description="Duration label" />
                    }
                    value={durationFormatted}
                />
            </div>
        </div>
    );
};

Summary.propTypes = propTypes;
Summary.defaultProps = defaultProps;

export default Summary;
